import React from 'react';
import PropTypes from 'prop-types';
import ContentLoaderPlaceholder from '@welldev-group/rcl-content-loader-placeholder';
import { TableData, TableRow } from '@welldev-group/rcl-table';

const TablePlaceholder = ({ numberOfColumn, numberOfRows }) => (
  <TableRow className="table-data-loader">
    {Array(numberOfColumn)
      .fill(0)
      .map((data, arrayIndex) => (
        <TableData key={(data + arrayIndex).toString()}>
          <ContentLoaderPlaceholder
            numberOfLines={numberOfRows}
            showBackground={false}
            isRounded={false}
          />
        </TableData>
      ))}
  </TableRow>
);

TablePlaceholder.defaultProps = {
  numberOfColumn: 1,
  numberOfRows: 1,
};

TablePlaceholder.propTypes = {
  numberOfColumn: PropTypes.number,
  numberOfRows: PropTypes.number,
};

export default TablePlaceholder;
